import React from 'react';
import { PureTranslator } from 'ggApp/modules/translator';
import Discount from 'ggApp/shared/icons/Discount';
import { Container, IconWrapper } from './styles';

export const VocherExplenation = (): JSX.Element => {
    return (
        <Container>
            <IconWrapper>
                <Discount size="24" color="#333" />
            </IconWrapper>
            <PureTranslator tk="CHECKOUT_VOUCHER_EXPLENATION" />
        </Container>
    );
};
